<template>
	<div id="">
		<div class=" overflow content_box" >
			<div class="list_box p_b_b" v-for="(item, index) in count" :key="index" infinite-scroll-disabled="disabled">
				<div class="p_flex p_f_a  p_m_t_20 ">
					<span class="type_size_18" v-html="item.title"></span>
				</div>
			</div>
			
		</div>
		<pagination @get="get" :index="num"/>
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue';
export default {
	data() {
		return {
			count: [],
			loading: false,
			num:0
		};
	},
	components:{
		pagination
	},
	created(){
		// console.log(this.$route.query.id)
		this.get()
	},
	mounted() {},
	methods: {
		get(id){
			// console.log(id)
			this.$request.ajax(this).post("/api_teacher/publish_exercise_detail_list",{
				job_publish_id:this.$route.query.id,
				page:id?id:1,    //第几页
				limit:10   //，每页显示
			}).then(res=>{
				// console.log(res)
				this.num=parseInt(res.data.count)
				this.count=res.data.list
				this.$emit("names",res.data.job_publish,res.data.count)
			})
		},
		goDeatils(){
			this.$router.push('/AnalyseDeatil');
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/list.css';
.content_box {
	padding: 0 260px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/perform/commponents/deatilList.vue